export const isObjectInstance = (value) => value instanceof Object;
